import AbstractWidget from "@/models/WebsiteWidget/AbstractWidget";
import WebsiteWidget from "@/models/WebsiteWidget/WebsiteWidget";

export default class ProductBlock extends AbstractWidget {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-widget/product-block';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteWidgetProductBlocks';

    static model_name = 'ProductBlock';

    static fields() {
		return {
			id: this.number(null).nullable(),
			product_id: this.number(null).nullable(),
			package_id: this.number(null).nullable(),
			parameters: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            widget: this.hasOne(WebsiteWidget, 'widgetable_id'),
		}
	}

    setParameters(parameters) {
        this.parameters = {
            country_id: parameters.country_id? Number(parameters.country_id): null,
            is_hotels: parameters.is_hotels =='1'?true:false,
            region_id: parameters.region_id? Number(parameters.region_id): null,
            in_website_category_ids: parameters.in_website_category_ids.map((id)=> Number(id)),
            tag_ids: parameters.tag_ids?.map((id)=> Number(id)),
            limit:Number(parameters.limit),
            has_tickets: parameters.has_tickets =='1'?true:false,
        }
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Widget() {
        return WebsiteWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }

}
